/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Style from './style';
import Widget from '../../widget';
import { getRowConfig } from './config';

export default function KeyIndicators({ data = {} }) {
  const { t } = useTranslation();
  const config = useMemo(() => getRowConfig(t, data), [t, data]);

  return (
    <Widget
      className="with-border-header"
      title={t('Key Indicators')}>
      <Style className='flex'>
        {config.map((c, i) => (
          <div className='row-item' key={`key-indicators-${i}`}>
            <h4>{c.label}</h4>
            <div className='flex'>
              {c.render()}
            </div>
          </div>
        ))}
      </Style>
    </Widget>
  )
}
